import { Box, CircularProgress, Grid2 } from "@mui/material";

import { FiltersContextProvider } from "components/contexts";
import {
  AdditionalReadings,
  CurrentPower,
  CurrentPricesWidget,
  EarningsWidget,
  EnergyChart,
  EnergyInfoSummaryLiveData,
  EnergyInfoToday,
  Forecast,
  InverterSummary,
  StrategyWidget,
} from "components/elements/widgets";
import { useRecordsData } from "components/elements/widgets/EnergyChart/hooks";
import { RECORDS, STATISTICS } from "routes/consts";
import { getLiveData, getSelectedPowerPlant, useAppSelector } from "store";

const DashboardEnergyChart = () => {
  const recordsData = useRecordsData(true);
  return (
    <EnergyChart
      {...recordsData}
      url={RECORDS}
      dashboard
      data={recordsData.data ?? []}
    />
  );
};

export const DashboardPage = ({
  pricesFlashId,
}: {
  // Set by the pull-to-refresh wrapper so the prices widget acknowledges a
  // pull the same way the prices page acknowledges its refresh button.
  pricesFlashId?: number;
}) => {
  const liveData = useAppSelector(getLiveData);
  const selectedPowerPlant = useAppSelector(getSelectedPowerPlant);

  if (!liveData)
    return (
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <CircularProgress />
      </Box>
    );

  return (
    <Grid2 container spacing={2} p={2} width={"100%"}>
      <CurrentPower />
      <FiltersContextProvider>
        <EnergyInfoToday icon="solar_power" url={STATISTICS} />
        <Forecast />
        <DashboardEnergyChart />
      </FiltersContextProvider>
      {selectedPowerPlant?.showMarketPrices && (
        <>
          <CurrentPricesWidget flashId={pricesFlashId} />
          <EarningsWidget />
          <StrategyWidget />
        </>
      )}
      <FiltersContextProvider initialState={{ dateType: ["month", "year"] }}>
        <EnergyInfoSummaryLiveData url={STATISTICS} />
      </FiltersContextProvider>
      <InverterSummary />
      <AdditionalReadings />
    </Grid2>
  );
};
